import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const ExportIcon: FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd'
          d='M11.996 1.80005C12.6587 1.80005 13.196 2.3373 13.196 3.00004V13.1071L15.6516 10.6515C16.1202 10.1829 16.88 10.1829 17.3487 10.6515C17.8173 11.1201 17.8173 11.8799 17.3487 12.3485L12.8487 16.8485C12.6138 17.0834 12.3058 17.2005 11.998 17.2C11.9973 17.2 11.9967 17.2 11.996 17.2C11.6344 17.2 11.3101 17.04 11.0901 16.7869L6.65165 12.3485C6.18302 11.8799 6.18302 11.1201 6.65165 10.6515C7.12028 10.1829 7.88007 10.1829 8.3487 10.6515L10.796 13.0988V3.00004C10.796 2.3373 11.3333 1.80005 11.996 1.80005ZM21.0001 10.8C21.6629 10.8 22.2001 11.3373 22.2001 12V21C22.2001 21.6627 21.6629 22.2 21.0001 22.2H3.0002C2.33746 22.2 1.8002 21.6627 1.8002 21V12.0042C1.8002 11.3414 2.33746 10.8042 3.0002 10.8042C3.66293 10.8042 4.20019 11.3414 4.20019 12.0042V19.8H19.8001V12C19.8001 11.3373 20.3374 10.8 21.0001 10.8Z'
          fill={color} />
  </svg>
)

export default ExportIcon
